module.exports = __webpack_public_path__ + "static/img/9-1.d116c29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/335/9-1.jpg
// module id = n2BW
// module chunks = 0